import { css, StyleSheet } from 'aphrodite';
import { mixins } from 'consumer-components';

export const transitionSeconds = 1;
export const transitionMilliseconds = transitionSeconds * 1000;
// the subtraction below is a hack to avoid flickering on re-entrance.
// i tried to the solution suggested here but it didn't work :c
// https://github.com/reactjs/react-transition-group/issues/157
export const CSSTransitionTimeout = transitionMilliseconds - 100;

export function getAnimationFromKeyframe(keyframe: any, timingFunction: string) {
  return mixins.animate(keyframe, transitionSeconds, 'initial', timingFunction);
}

const exitTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
const entranceTimingFunction = 'ease-in';

export type TransitionStyle = 'fade' | 'fadeAndSlide';

const fade = {
  entrance: {
    '0%': {
      opacity: 0,
    },
    '75%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  exit: {
    '0%': {
      opacity: 1,
    },
    '25%': {
      opacity: 0,
    },
    '100%': {
      opacity: 0,
    },
  },
};

// For height transitions to work correctly, we need to set an explicit max-height (or height).
// We set a max-height because it allows more flexibility for children to set their own heights to be lower than
// the height we specify here. However, the layout will break if a child has a height greater than what we specify here.
// Setting a larger height makes transitions seem sharper for short elements.
// e.g. an element with height: 100px won't have any visual change while the transition is going
// from max-height: 500px to max-height: 100px. This means the transition will appear to not do anything for 80% of the
// duration and then suddenly do everything in the last 20%.
const maxChildHeight = 200;
const fadeAndSlide = {
  entrance: {
    '0%': {
      opacity: 0,
      maxHeight: 0,
    },
    '50%': {
      opacity: 0,
      maxHeight: 0,
    },
    '75%': {
      opacity: 1,
    },
    '100%': {
      maxHeight: maxChildHeight,
    },
  },
  exit: {
    '0%': {
      opacity: 1,
      maxHeight: maxChildHeight,
    },
    '25%': {
      opacity: 0,
    },
    '50%': {
      maxHeight: 0,
    },
    '100%': {
      opacity: 0,
      maxHeight: 0,
    },
  },
};

const styles = StyleSheet.create({
  default: {
    overflow: 'hidden',
  },

  fadeAndSlideEntrance: getAnimationFromKeyframe(fadeAndSlide.entrance, entranceTimingFunction),
  fadeAndSlideExit: getAnimationFromKeyframe(fadeAndSlide.exit, exitTimingFunction),

  fadeEntrance: getAnimationFromKeyframe(fade.entrance, entranceTimingFunction),
  fadeExit: getAnimationFromKeyframe(fade.exit, exitTimingFunction),
});

export const classNameConfigs = {
  fadeAndSlide: {
    enter: css(styles.default),
    enterActive: css(styles.fadeAndSlideEntrance),
    exit: css(styles.default),
    exitActive: css(styles.fadeAndSlideExit),
  },

  fade: {
    enter: css(styles.default),
    enterActive: css(styles.fadeEntrance),
    exit: css(styles.default),
    exitActive: css(styles.fadeExit),
  },
};
